import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import selectFeature from '~/selectors/selectFeature';

export default (feature) => {
  const selector = useMemo(() => selectFeature(feature), [feature]);

  return useSelector(selector);
};
